"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ApplicantsProfile_1 = require("./ApplicantsProfile");
exports.default = ApplicantsProfile_1.ApplicantsProfile;
